<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch">
      </dynamic-search>
      <div class="data-table-box">
      <edit-data-table
        :loading="loading"
        :head="tableHead"
        rowKeyField="id"
        ref="editTable"
        show-number
        :data="list"
        :total="total"
        :offset="offset"
        :page="page"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange">
        <template v-slot:toolbar="{row}">
          <el-button size="mini" type="text" icon="el-icon-view" v-if="row.status === 0" @click="subLook(row)"/>
        </template>
      </edit-data-table>
    </div>
    </el-card>

    <drag-dialog
      append-to-body
      :show.sync="dialogVisible"
      destroy-on-close
      title="错误信息"
      enable-drag
      :min-height="300"
      width="800px">
      <div v-html="exDetail" />
    </drag-dialog>
  </div>
</template>

<script>
  import "@/components/EditDataTable"
  import DragDialog from '@/components/DragDialog'
  import DynamicSearch from '@/components/DynamicSearch/index.vue'
  import DataTableMixin from '@/mixins/DataTableMixin'

  export default {
    name: "TaskLog",
    mixins: [DataTableMixin],
    components: {
      DynamicSearch,
      DragDialog
    },
    data() {
      return {
        delLoading: false,
        dialogVisible: false,
        tableHead: [
          {
            label: '任务名称',
            prop: 'taskName',
          }, {
            label: 'Bean名称',
            prop: 'beanName',
            query: {
              type: 'input'
            },
          }, {
            label: '执行方法名称',
            prop: 'methodName',
          }, {
            label: '方法参数',
            prop: 'params',
            width: 100
          }, {
            label: '任务状态',
            prop: 'status',
            width: 100,
            formatter: (val) => {
              return val === 1 ? '执行成功' : '执行失败'
            }
          }, {
            label: '耗时',
            prop: 'timeConsuming',
            width: 100
          }, {
            label: '错误信息',
            prop: 'errorInfo',
            width: 100
          }, {
            label: '执行时间',
            prop: 'created',
            width: 160,
            sortable: true,
          },
        ],
        exDetail: null
      }
    },
    created() {
      this.$nextTick(() => {
        this.dataTableInit()
      })
    },
    methods: {
      dataTableBeforeInit() {
        this._url = '/sysScheduledTaskConfiguration/logs'
        const params = {page: this.page, size: this.offset}
        this._params = Object.assign(params, this._query)
        return true
      },
      subLook(row) {
        this.dialogVisible = true
        this.exDetail = row.errorInfo
      },
    }
  }
</script>

<style scoped lang="scss">

  .tree-container-scroll {
    padding-top: 15px;
    height: 400px;

    /deep/ .el-scrollbar__wrap {
      overflow-x: auto;
    }
  }

  /deep/ .splitter-pane-resizer {
    background-color: #ffffff;
  }
</style>
